import { useState, useEffect } from 'react';
import ComponentNotifier from '../../../../services/wss/ComponentNotifier';
import topicGroupSearchEngine from './TopicGroupSearchEngine';

const _engine = 'TopicGroupSearchEngine';

/**
 * Paint trigger for TopicGroupSearchEngine.
 * Repaint only — no business logic.
 * @returns {{ results: object[], loading: boolean, query: string }}
 */
export default function useTopicGroupSearch() {
    const [state, setState] = useState(() => ({
        results: topicGroupSearchEngine.getResults(),
        loading: topicGroupSearchEngine.isLoading(),
        query: topicGroupSearchEngine.getQuery(),
    }));

    useEffect(() => {
        const unsub = ComponentNotifier.subscribe(_engine, (e) => {
            setState({
                results: e.data.results,
                loading: e.data.loading,
                query: e.data.query,
            });
        });
        return () => unsub();
    }, []);

    return state;
}
